module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "preface",
    attrs: {
      "id": "prf"
    }
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "pageix"
    }
  }), _vm._v("Those who would give up essential liberty to purchase a little temporary safety deserve neither liberty nor safety.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("—Benjamin Franklin (1759)")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("The only thing we have to fear is fear itself.")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("—Franklin D. Roosevelt (1932)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-785c936c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781429954631_epub_prf_r1.vue
// module id = 72
// module chunks = 0